module.exports = "https://trybtryb-legacy.web.app/img/black-ice.f4cb8fa6.webp";